var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('app-list')
        ko.components.register('app-list', {
            viewModel: function (params) {
                var $this = this;
                var runApp = common.urlSearch(location.href)["runApp"];
                console.log(runApp)
                $this.visible = ko.observable(false);
                var items = common.fetch("/auth/account/app/list").data;
                var allapp = commonLocal.app.allapp;
                $this.items = ko.observableArray(items);
                $this.activeType = ko.observable(allapp);
                $this.item = ko.observable("");
                $this.options = ko.observableArray();
                var getAppClassification = common.fetch("/auth/account/app/getAppClassification").data;
                $this.category = getAppClassification?JSON.parse(getAppClassification.appClassJson):{allapp:[]}
                if(runApp){
                    for(var i=0;i<items.length;i++){
                        if(items[i].url == runApp){
                            $this.item(items[i]);
                            $this.options(items[i].accountNameList);
                            $this.visible(true);
                        }
                    }
                }

                $this.getCategory = function(category){
                    var categoryList = [allapp];
                    for(var c in category){
                        if(c != allapp){
                            // 分组数据大于0时展示出来
                            if(category[c].length > 0){
                                categoryList.push(c);
                            }
                        }
                    }
                    return categoryList;
                }
                $this.types = $this.getCategory($this.category);
                console.log($this.types);
                $this.getApps = function(list){
                    console.log(list);
                    var appList = [];
                    for(var i=0;i<items.length;i++){
                        if(list.indexOf(items[i].id)>-1){
                            appList.push(items[i]);
                        }
                    }
                    return appList;
                }
                $this.changeType = function(type){
                    $this.activeType(type);
                    var selectList = $this.category[type]?$this.category[type]:[];
                    if(type === allapp){
                        $this.items(items);
                    }else{
                        $this.items($this.getApps(selectList));
                        console.log($this.items())
                    }
                }
                $this.isEnable = function(event){
                    $this.visible($this.visible()?false:true)
                }
                $this.coverSSO = function () {
                    var account = $("#maskApp").val();
                    var param = "";
                    // 如果传给login页面state参数时就在选择时传给后端
                    if(sessionStorage.getItem("state")){
                        param = "&state=" + sessionStorage.getItem("state");
                    }
                    // 如果带了参数就使用带过来的参数
                    if(common.urlSearch(location.href)["state"]){
                        param = "&state=" + common.urlSearch(location.href)["state"];
                    }
                    window.open("/auth/sso/login/"+$this.item().url+"?accountName=" + account + param, '_blank');
                }
            },
            template: require("./template/AppList.html")
        });
        document.createElement('app-card')
        ko.components.register('app-card', {
            viewModel: function (params) {
                var $this = this;
                var ua = navigator.userAgent.toLowerCase();
                var isIE = ua.indexOf("msie") > -1;
                var safariVersion;
                if (isIE) {
                    safariVersion = ua.match(/msie ([\d.]+)/)[1];
                }
                $this.app = params.app;
                $this.mId = ko.observable("");
                //console.log($this.app)
                $this.accountDropMenu = {
                    isDropMenuDisplay: ko.observable(false),
                    className: "accountDropMenu",
                    items: ko.observableArray(),
                    id:$this.app.id
                };
                $this.defaultEntitlement = ko.observable();
                $this.defaultEntitlement.subscribe(function (newValue) {
                    var options = $this.accountDropMenu.items;
                    options.removeAll();
                    for (i in $this.app.accountNameList) {
                        var accountName = $this.app.accountNameList[i].displayName;
                        if (newValue.displayName !== accountName) {
                            options.push({
                                name: accountName,
                                index: i,
                                icon: "",
                                action: function (data) {
                                    $this.defaultEntitlement($this.app.accountNameList[data.index]);
                                    $this.triggerDropMenu();
                                    console.log($this.defaultEntitlement())
                                }
                            });
                        }
                    }
                    var oArrs = [];
                    if (safariVersion == 8.0) {
                        for(var i=0;i<options().length;i++){
                            if(options()[i].name){
                                oArrs.push(options()[i]);
                            }
                        }
                        $this.accountDropMenu.items(oArrs);
                    };
                });
                $this.selectTimes = function(time){
                    if(time == 0){
                        return "未使用"
                    }else{
                        return common.selectTimes(time) + "前"
                    }
                }
                $this.defaultEntitlement($this.app.accountNameList?$this.app.accountNameList[0]:"");
                $this.triggerDropMenu = function (e) {
                    //var oEvent = e || event;
                    //oEvent.stopPropagation();
                    //common.preventBubble();
                    var old = $this.accountDropMenu.isDropMenuDisplay()
                    $this.accountDropMenu.isDropMenuDisplay(!old);
                }

                $this.sso = function () {
                    var account = $this.defaultEntitlement()?$this.defaultEntitlement().accountName:"";
                    var subjectId = $this.defaultEntitlement()?$this.defaultEntitlement().subjectId:"";
                    var url = "?accountName="+account+"&subjectId="+subjectId;
                    var isLogin = common.fetch("/auth/isLogin").data;
                    console.log(isLogin)
                    if(isLogin){
                        window.open("/auth/sso/login/"+$this.app.url + url, '_blank');
                    }else{
                        common.redirectTo("/#/");
                    }
                    // var entitlementId = $this.defaultEntitlement().id;
                    // console.log($this.app)
                    // var runApp = common.urlSearch(location.href)["runApp"];
                    // var callBack = common.urlSearch(location.href)["callBack"]?common.urlSearch(location.href)["callBack"]:"";
                    // var isAdmin = $this.app.admin;
                    // if(runApp == $this.app.name){
                    //     var win = window.open("/#/sso?entitlementId=" + entitlementId +"&callBack=" + callBack, '_blank');
                    //     win.focus();
                    // }else{
                    //     var win = window.open("/#/sso?entitlementId=" + entitlementId, '_blank');
                    //     win.focus();
                    // }
                    // $this.appData = common.fetch("/auth/app/showMyapp").data;
                    // var items = $this.appData.data.PC[0].items;
                    // for(var i=0;i<items.length;i++){
                    //     if(items[i].name == runApp){
                    //         $this.item(items[i]);
                    //         $this.options(items[i].entitlementList);
                    //     }
                    // }
                }
                var arrs = [];
                if (safariVersion == 8.0) {
                    for(var i=0;i<$this.accountDropMenu.items().length;i++){
                        if($this.accountDropMenu.items()[i].name){
                            arrs.push($this.accountDropMenu.items()[i]);
                        }
                    }
                    $this.accountDropMenu.items(arrs);
                };
                $this.appConfig = function (e) {
                    //e.stopPropagation();
                    common.redirectTo("/#/appConfig/" + $this.app.id)
                }
            },
            template: require("./template/AppCard.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/appList/AppList.js
// module id = 116
// module chunks = 0